/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div span .countdown{display:inline-flex!important}  div span .countdown .measurements.d,   div span .countdown .measurements.h,   div span .countdown .measurements.m,   div span .countdown .measurements.s{display:inline-flex}  div span .countdown .measurements.d::after,   div span .countdown .measurements.h::after,   div span .countdown .measurements.m::after{content:\":\"}  p.measurements-text{display:inline-flex}  p.measurements-number{display:inline-flex}\n/*# sourceMappingURL=como-funciona.component.css.map*/"];
export { styles as styles };
